import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, PieChart, Pie, Cell } from 'recharts';
import Icon from '../../../components/AppIcon';

const RegionalDistribution = () => {
  const regionalData = [
    { region: 'Norte', members: 1245, percentage: 28.5, color: '#1e3a8a' },
    { region: 'Sul', members: 987, percentage: 22.6, color: '#0ea5e9' },
    { region: 'Nordeste', members: 856, percentage: 19.6, color: '#059669' },
    { region: 'Sudeste', members: 743, percentage: 17.0, color: '#d97706' },
    { region: 'Centro-Oeste', members: 534, percentage: 12.3, color: '#dc2626' }
  ];

  const totalMembers = regionalData?.reduce((sum, item) => sum + item?.members, 0);

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload?.length) {
      return (
        <div className="bg-popover border border-border rounded-md shadow-deep p-3">
          <p className="text-sm font-medium text-foreground">{label}</p>
          <p className="text-sm text-primary">
            Members: {payload?.[0]?.value?.toLocaleString()}
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-foreground">Distribuição Regional</h3>
        <div className="flex items-center space-x-2 text-sm text-muted-foreground">
          <Icon name="Users" size={16} />
          <span>{totalMembers?.toLocaleString()} Total de Membros</span>
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Bar Chart */}
        <div>
          <h4 className="text-sm font-medium text-foreground mb-4">Membros por Região</h4>
          <div className="w-full h-64">
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={regionalData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
                <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
                <XAxis 
                  dataKey="region" 
                  tick={{ fontSize: 12, fill: 'var(--color-muted-foreground)' }}
                  angle={-45}
                  textAnchor="end"
                  height={80}
                />
                <YAxis tick={{ fontSize: 12, fill: 'var(--color-muted-foreground)' }} />
                <Tooltip content={<CustomTooltip />} />
                <Bar dataKey="members" fill="var(--color-primary)" radius={[4, 4, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>

        {/* Pie Chart */}
        <div>
          <h4 className="text-sm font-medium text-foreground mb-4">Distribuição Percentual</h4>
          <div className="w-full h-64">
            <ResponsiveContainer width="100%" height="100%">
              <PieChart>
                <Pie
                  data={regionalData}
                  cx="50%"
                  cy="50%"
                  innerRadius={40}
                  outerRadius={80}
                  paddingAngle={2}
                  dataKey="members"
                >
                  {regionalData?.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={entry?.color} />
                  ))}
                </Pie>
                <Tooltip content={<CustomTooltip />} />
              </PieChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
      {/* Regional Summary */}
      <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
        {regionalData?.map((region, index) => (
          <div key={index} className="flex items-center space-x-3 p-3 bg-muted rounded-md">
            <div 
              className="w-4 h-4 rounded-full flex-shrink-0"
              style={{ backgroundColor: region?.color }}
            />
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-foreground truncate">{region?.region}</p>
              <div className="flex items-center space-x-2">
                <span className="text-sm text-muted-foreground">{region?.members?.toLocaleString()}</span>
                <span className="text-xs text-muted-foreground">({region?.percentage}%)</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RegionalDistribution;